module.exports = __webpack_public_path__ + "media/fonts/Inter-ExtraLight-fbcf1d9a.ttf";